import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { FormGrid } from "../Users/AddANewUser";
// import Select from "../../Select";
import GoBack from "../sub-components/GoBack";
import TreeFellItems, { withoutDisplayFields } from "./sub-components/TreeFellItems";
import Select from 'react-select';
import { LogService } from "../../../services/LogService";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../../services/UserService";
import { StockService } from "../../../services/StockService";
import { useSpeciesOptions } from "./shared/useSpeciesOptions";
import { nanoid } from "nanoid";
const AddTreeFell = () => {
  let history = useNavigate();
  const [state, setState] = useState({
    managerId: 0,
    supervisorId: 0,
    description: "",
    totalQuantity: "",
    teamId: 0,
    clerkId: 0,
    treeFellItems: [],
  });


  const [selectedManagerOption, setSelectedManagerOption] = useState(null);
  const [selectedTeamOption, setSelectedTeamOption] = useState(null);

  


  const handleManagerChange = (e) => {
    setSelectedManagerOption(e);
    setState((s) => ({ ...s, managerId: e ? e.value : 0 }));
  };


  const handleTeamChange = (e) => {
    setState((s) => ({ ...s, managerId: e.managerId, driverId: e.driverId, supervisorId: e.supervisorId, teamId: e.teamId }));
    setSelectedTeamOption(e);
    setSelectedManagerOption(users.find((u) => u.userId === e.managerId) || null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // state.teamMembers = teamMembers;
    //  console.log(state);
    //  console.log(treeFellItems);
    const toastId = toast.loading("Creating new Tree fell ... ");
     LogService.CreateTreeFell(
       state.teamId,
       state.description,
       state.clerkId,
       state.supervisorId,
       state.managerId,
       state.totalQuantity,
       treeFellItems.map((i) => withoutDisplayFields({ ...i, speciesId: speciesOptions.speciesIdFor(i) }))
     ).then((res) => {
       toast.dismiss(toastId);
       if (res.Successful) {
         toast.success(res.message);
         history("/dashboard/tree-fell");
         
       } else {
         toast.error(res.message);
       }
     });
  };

  const [users, setUsers] = useState([]);
  const loadUsers = () => {
    UserService.GetAllInternalUsers().then((res) => {
      let data = res.map((user)=>{
        user.value = user.userId;
        user.label = user.firstName+' '+user.lastName;
        return user;
     })
      setUsers(...users, data);
    });
  };

  const [teams, setTeams] = useState([]);
  const loadTeams = () => {
    StockService.GetTeams().then((res) => {
      let data = res.map((user)=>{
        user.value = user.teamId;
        user.label = user.teamName;
        return user;
     })
      setTeams(...users, data);
    });
  };

   useEffect(() => {
       loadUsers();
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
    loadTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const speciesOptions = useSpeciesOptions();

const [treeFellItems, setTreeFellItems] = useState([
  {
    description: "",
    diameter1: 0,
    diameter2: 0,
    diameter3: 0,
    diameter4: 0,
    quantity: 1,
    volume: 0,
    length: 0,
    speciesId: 0,
    id: nanoid(),
  },
]);

useEffect(() => {
  console.log(treeFellItems);
  let totalQty = treeFellItems.map(item => parseInt(item.quantity)).reduce((prev, next) => prev + next);
  setState({...state, totalQuantity:totalQty});
  // let totalQty = treeFellItems.map(item => parseInt(item.quantity)).reduce((prev, next) => prev + next);
  // setState({...state, totalQuantity:totalQty});
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [treeFellItems]);
  return (
    <>
     <GoBack />
     <form className="flex flex-col w-full" onSubmit={handleSubmit}>
      <h2 className="my-2 text-xl font-medium text-gray-700 ">New TreeFell</h2>
      <FormGrid>
        {/* <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Manager</span>
          <Select
            id="managerId"
            type="text"
            options={users}
            value={selectedManagerOption }
            onChange={handleMangerChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Supervisor</span>
          <Select
            id="supervisorId"
            type="text"
            options={users}
            value={selectedSupervisorOption}
            onChange={handleSupervisorChange}
            required
            
          />
        </label> */}

        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Team</span>
          <Select
            label="Select a Team"
            options={teams}
            value={selectedTeamOption}
            onChange={handleTeamChange}
            required
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Manager</span>
          <Select
            inputId="managerId"
            options={users}
            value={selectedManagerOption}
            onChange={handleManagerChange}
            required
          />
        </label>
      </FormGrid>
      <h2>Items</h2>
      <TreeFellItems speciesOptions={speciesOptions} setTreeFellItems={setTreeFellItems} treeFellItems={treeFellItems} />
      <button
        type="submit"
        className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
      >
        Create TreeFell
      </button>
    </form>
    </>
   
  );
};

export default AddTreeFell;
